import { useQuery } from "@tanstack/react-query";
import { apiV2 } from "libs/api/src/lib/apiV2";

import { Spinner } from "../atoms";
import { MemberEmailForm } from "./MemberProfile/MemberEmailForm";
import { MemberForm } from "./MemberProfile/MemberForm";
import { MemberMarketingOptionsForm } from "./MemberProfile/MemberMarketingOptionsForm";
import { MemberOtherSettingsForm } from "./MemberProfile/MemberOtherSettingsForm";
import { SettingsSection } from "./SettingsSection";

export function UserMemberProfile({ memberId }: { memberId: string }) {
  const { isLoading: isLoadingMemberProfile } = useQuery(
    apiV2.staff.member.queries.id(memberId),
  );
  const { isLoading: isLoadingMember } = useQuery(
    apiV2.staff.member.queries.idDeprecated(memberId),
  );

  if (isLoadingMemberProfile || isLoadingMember) {
    return <Spinner />;
  }

  return (
    <div className="-mx-4 -mb-8 flex max-h-full flex-col overflow-y-auto px-4 pb-8 lg:-mx-8 lg:px-8">
      <div className="relative flex size-full max-h-full flex-col">
        <div className="-mt-4 flex flex-col pb-48">
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Account"
              subTitle="Setup or update the users account"
            />
            <SettingsSection.Content>
              <MemberEmailForm memberId={memberId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Other Settings"
              subTitle="Update club or other settings."
            />
            <SettingsSection.Content>
              <MemberOtherSettingsForm memberId={memberId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Profile Information"
              subTitle="Update the users basic information."
            />
            <SettingsSection.Content>
              <MemberForm memberId={memberId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
          <SettingsSection.Container>
            <SettingsSection.TitleContainer
              title="Notifications"
              subTitle="Set the users notification preferences."
            />
            <SettingsSection.Content>
              <MemberMarketingOptionsForm memberId={memberId} />
            </SettingsSection.Content>
          </SettingsSection.Container>
        </div>
      </div>
    </div>
  );
}
